import './tooltip.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var TOOLTIP_MAX_WIDTH = 480;
export var actionsContainer = '_1j1seex12-3-5-0';
export var chevron = '_1j1seexk-3-5-0';
export var chevronRightAligned = '_1j1seexl-3-5-0';
export var divider = '_1j1seexy-3-5-0';
export var headerText = '_1j1seexs-3-5-0';
export var multiLineName = '_1j1seexx-3-5-0';
export var relativeValueStyle = '_1j1seexp-3-5-0';
export var seriesActionHeader = '_1j1seex10-3-5-0';
export var seriesActionHeaderMaxLinesVar = 'var(--_1j1seex2-3-5-0)';
export var seriesActionHeaderMultiLine = '_1j1seex11-3-5-0';
export var seriesGridContainer = '_1j1seexb-3-5-0';
export var seriesHeader = '_1j1seex7-3-5-0';
export var seriesHeaderName = '_1j1seex8-3-5-0';
export var seriesHeaderValue = '_1j1seex9-3-5-0';
export var seriesItem = _7a468({defaultClassName:'_1j1seexe-3-5-0',variantClassNames:{symbolPosition:{left:'_1j1seexf-3-5-0',right:'_1j1seexg-3-5-0'},hasChevron:{true:'_1j1seexh-3-5-0'}},defaultVariants:{symbolPosition:'left',hasChevron:false},compoundVariants:[]});
export var seriesItemActive = '_1j1seexm-3-5-0';
export var seriesItemHighlighted = '_1j1seex13-3-5-0';
export var seriesItemMaxWidthVar = 'var(--_1j1seex1-3-5-0)';
export var seriesItemText = '_1j1seexn-3-5-0';
export var seriesItemWithChevron = '_1j1seexj-3-5-0';
export var seriesItemWrapper = '_1j1seexi-3-5-0';
export var seriesNameCell = '_1j1seexv-3-5-0';
export var seriesNameMaxLinesVar = 'var(--_1j1seex0-3-5-0)';
export var seriesNameText = '_1j1seext-3-5-0';
export var seriesNameTextMultiLine = '_1j1seexo-3-5-0';
export var seriesOverflowContainer = '_1j1seexd-3-5-0';
export var seriesOverflowContainerBase = '_1j1seexc-3-5-0';
export var seriesValueCell = '_1j1seexw-3-5-0';
export var seriesValueText = '_1j1seexu-3-5-0';
export var seriesWrapper = '_1j1seexa-3-5-0';
export var spaceSavedForSymbolVar = 'var(--_1j1seex3-3-5-0)';
export var symbolRight = '_1j1seexz-3-5-0';
export var symbolWrapper = _7a468({defaultClassName:'_1j1seexq-3-5-0',variantClassNames:{isRight:{true:'_1j1seexr-3-5-0'}},defaultVariants:{},compoundVariants:[]});
export var wrapper = _7a468({defaultClassName:'_1j1seex4-3-5-0',variantClassNames:{isInteractive:{true:'_1j1seex5-3-5-0',false:'_1j1seex6-3-5-0'}},defaultVariants:{},compoundVariants:[]});